import type { ConceptDef } from '../types';

export const sortOddOneOut: ConceptDef = {
  kind: 'oddOneOut',
  id: 'sort-odd-one-out',
  label: 'Sort Odd-One-Out',
  category: 'Sorting',
  description: 'See a small group; tap the one that does not belong.',
  config: {
    promptMode: 'AUDIO',
    items: [
      { say: '🍎 apple, 🍌 banana, 🍇 grapes', answer: '🐶 dog' },
      { say: '🚗 car, 🚌 bus, 🚲 bike', answer: '🍕 pizza' },
      { say: 'A, B, C', answer: '4' },
      { say: '⚽ ball, 🧸 teddy, 🪀 yo-yo', answer: '👕 t-shirt' },
      { say: '☁️ cloud, 🌙 moon, ⭐ star', answer: '🐟 fish' },
      { say: '☀️ sun, 🔥 fire, ☕ hot drink', answer: '🧊 ice' },
    ],
  },
};
